module.exports = __webpack_public_path__ + "static/media/life-insurance-card-img.a7528327.png";